/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DeviceUpdateDto = {
  /**
   * New status to be assigned to the device.
   */
  status: DeviceUpdateDto.status;
};
export namespace DeviceUpdateDto {
  /**
   * New status to be assigned to the device.
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    DEACTIVATED = 'DEACTIVATED',
    FOR_RETURN = 'FOR_RETURN',
  }
}

